import React from 'react';

import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useServiceModeContext } from 'state/service-mode';

import { FORCE_MENU_FEATURE_UPSELL_STRATEGY } from './constants';
import { IUpsellStrategyProps } from './types';
import { Upsell } from './upsell';
import useDeepflameUpsell from './use-deepflame-upsell';
import useMenuFeatureUpsell from './use-menu-feature-upsell';

const MenuFeatureUpsell: React.FC<IUpsellStrategyProps> = props => {
  const upsellData = useMenuFeatureUpsell();
  return <Upsell {...upsellData} {...props} />;
};

const DeepflameUpsell: React.FC<IUpsellStrategyProps> = props => {
  const upsellData = useDeepflameUpsell();
  return <Upsell {...upsellData} {...props} />;
};

export const UpsellStrategy: React.FC<IUpsellStrategyProps> = props => {
  const { isAuthenticated } = useAuthContext();
  const isSignedIn = isAuthenticated();

  const { isCatering } = useServiceModeContext();

  const isChefDeprecated = useFlag(LaunchDarklyFlag.DEPRECATE_CHEF);
  const enableSignupAfterCart = useFlag(LaunchDarklyFlag.ENABLE_MOVE_SIGNUP_AFTER_CART);
  const chefRecommendationEngine2 = useFlag(LaunchDarklyFlag.CHEF_RECOMMENDATION_ENGINE_2);
  const isChefEngineSanity = chefRecommendationEngine2?.toLowerCase() === 'sanity';

  const shouldUseMenuFeatureUpsell =
    FORCE_MENU_FEATURE_UPSELL_STRATEGY ||
    (!isChefDeprecated && !isSignedIn && enableSignupAfterCart) ||
    isChefEngineSanity;

  if (shouldUseMenuFeatureUpsell || isCatering) {
    return <MenuFeatureUpsell {...props} />;
  }

  if (isChefDeprecated) {
    return <DeepflameUpsell {...props} />;
  }

  return null;
};
